import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Save, Send, CalendarClock } from "lucide-react";
import { API } from "@/lib/api";

export const ReportSettingsCard = () => {
  const [cfg, setCfg] = useState({ enabled: false, email: "" });
  const [saving, setSaving] = useState(false);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    axios.get(`${API}/settings/report`).then((r) => setCfg(r.data)).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await axios.post(`${API}/settings/report`, cfg);
      toast.success("Report-Einstellungen gespeichert");
    } catch { toast.error("Speichern fehlgeschlagen"); }
    finally { setSaving(false); }
  };

  const sendNow = async () => {
    setSending(true);
    try {
      await axios.post(`${API}/report/send-now`);
      toast.success("Monatsreport wurde versendet");
    } catch (e) { toast.error(e.response?.data?.detail || "Versand fehlgeschlagen"); }
    finally { setSending(false); }
  };

  return (
    <Card className="p-6 bg-white border-[var(--brand-border)] lg:col-span-2" data-testid="settings-report-card">
      <div className="flex items-center gap-2 mb-1">
        <CalendarClock className="w-5 h-5 text-[var(--brand-primary)]" />
        <h3 className="font-[Playfair_Display] text-lg font-semibold text-[var(--brand-ink)]">Automatischer Monatsreport</h3>
      </div>
      <p className="text-sm text-[var(--brand-muted)] mb-4">Erhalte am 1. jedes Monats automatisch eine E-Mail mit Umsatz, Pipeline, offenen Beträgen und Aufgaben – ganz ohne manuellen Export. (Nutzt deine Resend-E-Mail-Konfiguration.)</p>
      <label className="flex items-center gap-3 mb-4 cursor-pointer select-none" data-testid="report-enabled-label">
        <input type="checkbox" checked={cfg.enabled} onChange={(e) => setCfg({ ...cfg, enabled: e.target.checked })} className="w-4 h-4 accent-[var(--brand-primary)]" data-testid="report-enabled" />
        <span className="text-sm font-medium text-[var(--brand-ink)]">Monatsreport automatisch senden</span>
      </label>
      <div className="max-w-md">
        <Label>Empfänger-E-Mail <span className="text-[var(--brand-muted)] font-normal">(leer = Firmen-E-Mail)</span></Label>
        <Input type="email" value={cfg.email || ""} onChange={(e) => setCfg({ ...cfg, email: e.target.value })} placeholder="z. B. inhaber@firma.de" data-testid="report-email" />
      </div>
      <div className="flex items-center gap-2 mt-4">
        <Button onClick={save} disabled={saving} className="bg-[var(--brand-primary)] hover:bg-[var(--brand-primary-dark)] text-white" data-testid="btn-save-report">
          <Save className="w-4 h-4 mr-1" /> {saving ? "Speichert …" : "Speichern"}
        </Button>
        <Button variant="outline" onClick={sendNow} disabled={sending} className="border-[var(--brand-border)]" data-testid="btn-send-report-now">
          <Send className="w-4 h-4 mr-1" /> {sending ? "Sendet …" : "Jetzt testen"}
        </Button>
      </div>
    </Card>
  );
};
